import React, { useMemo } from "react";
import img1 from "@assets/images/logo/LOGO-2-LIGHT.svg";
import img3 from "@assets/images/element/visa.svg";
import img4 from "@assets/images/element/mastercard.svg";
import img5 from "@assets/images/element/expresscard.svg";
import img6 from "@assets/images/logo/footer-link-pay.png";
import img7 from "@assets/images/logo/footer-apple-pay.png";
import img8 from "@assets/images/logo/footer-google-pay.png";
import {
  contactInfo,
  getContactInfo,
  // footerSections,
  getFooterSections,
  socialIcons,
} from "../../../../_mock-api's/index";
import { ILoginState } from "@share/store/slices";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useHistory } from "react-router-dom";

const Footer = () => {
  const login = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { account } = login;
  const footerBackgroundColorPref = account?.footerBackgroundColorDB;
  const footerFontsColor = account?.footerFontsColorDB;
  const footerBackgroundColor = useMemo(() => !isEmpty(footerBackgroundColorPref) ? footerBackgroundColorPref : '#1C1B23FF', [footerBackgroundColorPref]);
  const intl = useIntl();
  const footerSections = getFooterSections(intl);
  const contactInfo = getContactInfo(intl);
  const footerLogoPref = account?.footerLogoDB;
  const logo = useMemo(() => (!isEmpty(footerLogoPref) ? footerLogoPref : img1), [footerLogoPref]);
  const history = useHistory();
  const paymentLinks = [
    { key: 'pay', img: img6, link: 'https://www.paypal.com/us/home' },
    { key: 'apple', img: img7, link: import.meta.env.VITE_APPLE_PAY_REDIRECT_URL },
    { key: 'google', img: img8, link: import.meta.env.VITE_GOOGLE_PAY_REDIRECT_URL },
  ];
  const mobileLinks = [
    { key: 'apple', img: img7, link: import.meta.env.VITE_APPLE_PAY_REDIRECT_URL },
    { key: 'google', img: img8, link: import.meta.env.VITE_GOOGLE_PAY_REDIRECT_URL },
  ];
  
  const handleNavigate = (path: string) => { 
    history.push(path);
  };
  const handlePaymentsNavigate = (key: string) => {
    switch (key) {
      case 'pay':
        // window.open(paymentLinks[0].link, '_blank');
        break;
      case 'apple':
        window.open(paymentLinks[1].link, '_blank');
        break;
      case 'google':
        window.open(paymentLinks[2].link, '_blank');
        break;
      default:
        break;
    }
  };
  return (
    <>
      <footer className="pt-5" style={{ backgroundColor: footerBackgroundColor , color: footerFontsColor}}>
        <div className="container">
          <div className="row g-sm-4 gx-0 gy-4"> 
            <div className="col-lg-3">
              <a href="index.php">
                <img className="h-40px" src={logo} alt="logo" />
              </a>
              {contactInfo.map((info, index) => (
                <p key={index} className="mb-2 mt-3">
                  <span className="fw-bold" style={{ color: `${footerFontsColor ? footerFontsColor : '#747579'}` }}>
                    {info.label}
                  </span>{" "}
                  <br />
                  <a
                    href={`tel:${info.phone}`}
                    className={`text-primary-hover ${!footerFontsColor ? "text-body-secondary" : ""}`}
                    style={{ color: footerFontsColor || (index === 1 ? "white" : "#747579") }}
                  >
                    {info.phone}
                  </a>{" "}
                </p>
              ))}
            </div>

            <div className="col-lg-8 ms-auto">
              <div className="row gy-4">
                {footerSections.map((section, index) => (
                  <FooterSection
                    key={index}
                    title={section.title}
                    links={section.links}
                    footerFontsColor={footerFontsColor}
                    accountName={login?.account?.name}
                    intl={intl}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="row gx-0 gy-4 g-sm-4 justify-content-between mt-3 mt-md-4">
            <div className="col-sm-7 col-md-6 col-lg-4">
              <h5 className="mb-2" style={{ color: footerFontsColor ? footerFontsColor : 'white' }}><FormattedMessage id="footer.secure.payments" /></h5>
              <ul className="list-inline mb-0 mt-3 footerIcon">
              {paymentLinks.map(({ key, img }, index) => (
                <li key={key} className="list-inline-item">
                  <button
                    className="nav-link py-1"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    style={{
                      color: footerFontsColor ?? 'dark',
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                  >
                    <img src={img} alt={key} />
                  </button>
                </li>
              ))}
              </ul>
            </div>
            {/* <div className="col-sm-7 col-md-6 col-lg-4">
              <h5 className="mb-2" style={{ color: footerFontsColor ? footerFontsColor : 'white' }}><FormattedMessage id="footer.platformFeatures.continueInApp" /></h5>
              <ul className="list-inline mb-0 mt-3 footerIcon">
              {mobileLinks.map(({ key, img }, index) => (
                <li key={key} className="list-inline-item">
                  <button
                    className="nav-link py-1"
                    onClick={() => handlePaymentsNavigate(key)}
                    style={{
                      color: footerFontsColor ?? 'dark',
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                  >
                    <img src={img} alt={key} />
                  </button>
                </li>
              ))}
              </ul>
            </div> */}

            <div className="col-sm-5 col-md-6 col-lg-3 text-sm-end">
              <h5 className="mb-2" style={{ color: footerFontsColor ? footerFontsColor : 'white' }}><FormattedMessage id="footer.connect" /></h5>
              <ul className="list-inline mb-0 mt-3 ">
                {socialIcons.map((icon, index) => (
                  <li key={index} className="list-inline-item">
                    <a
                      className={`btn btn-sm shadow px-2 bg-${icon.color} mb-0`}
                      href={icon.link}
                    >
                      <i className={`fab fa-fw fa-${icon.icon}`}></i>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <hr className="mt-4 mb-0" />

          <div className="row">
            <div className="container">
              <div className="d-lg-flex justify-content-between align-items-center py-3 text-center text-lg-start">
                <div className="text-primary-hover" style={{ color: footerFontsColor ? footerFontsColor : 'dark' }}>
                  {" "}
                  <FormattedMessage id="footer.copyright" />
                  <a
                    href="https://www.travcoding.com/"
                    style={{ color: footerFontsColor ? footerFontsColor : 'dark' }}
                  >
                    &lt;<FormattedMessage id="footer.company.name" />&gt;
                  </a>{" "}
                </div>
                <div className="nav mt-2 mt-lg-0">
                  <ul className="list-inline text-primary-hover mx-auto mb-0">
                    <li className="list-inline-item me-0">
                      <button
                        className="nav-link py-1 me-3"
                        onClick={() => handleNavigate(`/${account?.name}/travbusiness-privacy-policy`)}
                        style={{
                          color: footerFontsColor ?? 'dark',
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                        }}
                      >
                        <FormattedMessage id="footer.privacy" />
                      </button>

                    </li>
                    <li className="list-inline-item me-0">
                      <button
                        className="nav-link py-1"
                        onClick={() => handleNavigate(`/${account?.name}/travbusiness-terms-of-use`)}
                        style={{
                          color: footerFontsColor ?? 'dark',
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                        }}
                      >
                        <FormattedMessage id="footer.terms" />
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="back-top"><FormattedMessage id="footer.ads" /></div>
    </>
  );
};

const FooterSection = ({ title, links , footerFontsColor, accountName,intl}) => {
    return (
      <div className="col-6 col-md-4" >
        <h5 className="mb-2 mb-md-4" style={{ color: footerFontsColor ? footerFontsColor : 'white' }}> {title}</h5>
        <ul className="nav flex-column text-primary-hover">
          {links.map((link, index) => (
            <li key={index} className="nav-item">
              <Link to={`/${accountName}${link.href}`} >
              <a className="nav-link"  style={{ color: footerFontsColor ? footerFontsColor : 'dark' }}>
                {/* {link.title} */} {intl.formatMessage({ id: link.id })}
              </a>
              </Link>
              
            </li>
          ))}
        </ul>
      </div>
    )
  };

export default Footer;
